import Input from '@repo/ui/input'
import MultiSelectInput from '@repo/ui/multiselect-input'
import RadioInput from '@repo/ui/radio-input'
import Typography from '@repo/ui/typography'

import {
  BillingTypeEnum,
  billingTypeEnumMapping
} from '../../../lib/types/enums/cse/billing-type.enum'
import {
  ReductionTypeEnum,
  reductionTypeEnumMapping
} from '../../../lib/types/enums/cse/reduction-type.enum'
import { CseFilter } from '../../../lib/types/models/cse/cse'

type Props = {
  filter?: CseFilter
  onFilterChange: (filter: CseFilter) => void
}

const CseFilters: React.FC<Props> = ({ filter, onFilterChange }) => {
  function setFilter<K extends keyof CseFilter>(key: K, value: CseFilter[K]) {
    onFilterChange({ ...filter, [key]: value })
  }

  return (
    <div className="flex flex-col gap-4">
      <MultiSelectInput
        label={'Type de facturation'}
        variant={'primary'}
        searchable
        options={Object.values(BillingTypeEnum).map((billingType) => ({
          label: billingTypeEnumMapping[billingType],
          value: billingType
        }))}
        onChange={(billingTypes) => setFilter('billingTypes', billingTypes)}
        selectedOptions={
          filter?.billingTypes
            ? filter.billingTypes.map((billingType) => ({
                label: billingTypeEnumMapping[billingType],
                value: billingType
              }))
            : undefined
        }
      />
      <MultiSelectInput
        label={'Type de réduction'}
        variant={'primary'}
        searchable
        options={Object.values(ReductionTypeEnum).map((reductionType) => ({
          label: reductionTypeEnumMapping[reductionType],
          value: reductionType
        }))}
        onChange={(reductionTypes) => setFilter('reductionTypes', reductionTypes)}
        selectedOptions={
          filter?.reductionTypes
            ? filter.reductionTypes.map((reductionType) => ({
                label: reductionTypeEnumMapping[reductionType],
                value: reductionType
              }))
            : undefined
        }
      />

      <div className="flex items-center gap-2 w-full">
        <Input
          type="text"
          containerClassName="flex-1"
          label={'Nbre de salaries min'}
          value={filter?.minNumberOfEmployees}
          onChange={(e) => setFilter('minNumberOfEmployees', Number(e.target.value))}
        />
        <Input
          type="text"
          containerClassName="flex-1"
          label="Nbre de salaries max"
          value={filter?.maxNumberOfEmployees}
          onChange={(e) => setFilter('maxNumberOfEmployees', Number(e.target.value))}
        />
      </div>
      <div className={'flex flex-col gap-2'}>
        <Typography variant={'label-semibold'}>Participation financière</Typography>
        <div className="flex flex-row gap-4">
          <RadioInput
            label={'Tous'}
            checked={filter?.councilAllowance === undefined}
            onCheck={() => setFilter('councilAllowance', undefined)}
          />
          <RadioInput
            label={'Oui'}
            checked={filter?.councilAllowance === true}
            onCheck={() => setFilter('councilAllowance', true)}
          />

          <RadioInput
            label={'Non'}
            checked={filter?.councilAllowance === false}
            onCheck={() => setFilter('councilAllowance', false)}
          />
        </div>
      </div>

      <div className={'flex flex-col gap-2'}>
        <Typography variant={'label-semibold'}>Statut</Typography>
        <div className="flex flex-row gap-4">
          <RadioInput
            label={'Tous'}
            checked={filter?.isActive === undefined}
            onCheck={() => setFilter('isActive', undefined)}
          />
          <RadioInput
            label={'Actif'}
            checked={filter?.isActive === true}
            onCheck={() => setFilter('isActive', true)}
          />

          <RadioInput
            label={'Inactif'}
            checked={filter?.isActive === false}
            onCheck={() => setFilter('isActive', false)}
          />
        </div>
      </div>
    </div>
  )
}

export default CseFilters
